import React, { useState, useEffect } from 'react';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import faqService from '../services/faqService';
import PageHeader from './PageHeader';
import SkeletonLoader from './SkeletonLoader';
import EmptyState from './EmptyState';
import './../pages/Dashboard.css';

const FaqManager = () => {
  const initialFormState = { pergunta: '', resposta: '' };
  const [faqs, setFaqs] = useState([]);
  const [formState, setFormState] = useState(initialFormState);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true); // Adiciona o estado de loading

  const fetchFaqs = async () => {
    setLoading(true);
    try {
      const data = await faqService.getFaqs();
      setFaqs(data);
    } catch (error) {
      console.error("Erro ao buscar FAQs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingId) {
      await faqService.updateFaq(editingId, formState);
    } else {
      await faqService.createFaq(formState);
    }
    fetchFaqs();
    resetForm();
  };

  const handleEdit = (faq) => {
    setEditingId(faq.id);
    setFormState({ pergunta: faq.pergunta, resposta: faq.resposta });
  };
  
  const handleDelete = async (id) => {
    if (window.confirm("Tem certeza que deseja deletar este FAQ?")) {
      await faqService.deleteFaq(id);
      fetchFaqs();
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setFormState(initialFormState);
  };

  return (
    <div className="page-container">
      <PageHeader title="Gerenciar FAQ" />

      <div className="content-area">
        <div className="card">
          <h3>{editingId ? 'Editar FAQ' : 'Adicionar Nova Pergunta'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="pergunta">Pergunta</label>
              <input id="pergunta" name="pergunta" className="form-input" value={formState.pergunta} onChange={handleInputChange} placeholder="ex: Qual o endereço?" required />
            </div>
            <div className="form-group">
              <label htmlFor="resposta">Resposta</label>
              <textarea id="resposta" name="resposta" className="form-input" value={formState.resposta} onChange={handleInputChange} placeholder="ex: Ficamos na Rua Principal, 123" required></textarea>
            </div>
            <div className="form-buttons">
              <button type="submit" className="btn btn-primary">
                {editingId ? 'Salvar Alterações' : 'Adicionar FAQ'}
              </button>
              {editingId && <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancelar</button>}
            </div>
          </form>
        </div>

        <div className="card">
          <h3>FAQs Cadastrados</h3>
          {loading ? (
            <div>
              <SkeletonLoader />
              <SkeletonLoader />
              <SkeletonLoader />
            </div>
          ) : faqs.length > 0 ? (
            <ul className="service-list">
              {faqs.map(faq => (
                <li key={faq.id}>
                  <div className="service-info">
                    <strong>{faq.pergunta}</strong>
                    <p>{faq.resposta}</p>
                  </div>
                  <div className="service-actions">
                    <button className="btn-icon" onClick={() => handleEdit(faq)}><FaPencilAlt /></button>
                    <button className="btn-icon btn-danger-icon" onClick={() => handleDelete(faq.id)}><FaTrash /></button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState
              message="Nenhuma pergunta frequente cadastrada."
              actionText="Adicionar primeira pergunta"
              onActionClick={() => document.querySelector('#pergunta')?.focus()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FaqManager;